import { RefAttributes } from 'react';
import { Input as RACInput, InputProps as RACInputProps } from 'react-aria-components';

import { merge } from '@/components';
import { DivProps } from '@/utils';

// XXX: defaultValue should be specified on the TextField - not on the Input element
export type InputProps = Omit<RACInputProps, 'defaultValue'> &
  RefAttributes<HTMLInputElement> & {
    props?: {
      container?: DivProps;
    };
  };

export const Input = ({ className, children, props, ...rest }: InputProps) => {
  /* prettier-ignore */
  const containerStyles = [
    'bg-white',
    'border-1',
    'border-gray-200',
    'flex',
    'font-regular',
    'has-[:disabled]:bg-gray-50',
    'items-center',
    'min-h-8',
    'outline-none',
    'p-2',
    'rounded-md',
    'shadow-xs',
    'w-full',
  ];

  /* prettier-ignore */
  const styles = [
    'grow',
    'bg-none',
    'data-[disabled]:cursor-not-allowed',
    'data-[disabled]:bg-gray-50',
    'data-[disabled]:text-gray-500',
    'outline-none',
    'text-sm',
    'font-medium',
    'text-gray-700'
  ];
  /* prettier-ignore */
  const lightStyles = [
    'placeholder:text-gray-400',
    'text-gray-900',
  ];

  const { className: containerClassName, ...containerProps } = props?.container ?? {};

  return (
    <div className={merge(containerStyles, containerClassName)} {...containerProps}>
      <RACInput className={merge(styles, lightStyles, className)} {...rest} />
      {children}
    </div>
  );
};
